import { connect } from 'react-redux';

import { History } from 'history';

import { appActions } from '../actions/appAction';
import { viewerActions } from '../actions/viewerAction';
import App from '../App';

export interface AppActions {
    initRevisionViewer: (actId: string, revision: string, miekesi: boolean, highlight: string, nodeId: string, mode: 'history' | 'current') => void;
    initEditingViewer: (actId: string, editingId: string, stepId: string, miekesi: boolean) => void;
    initExaminationViewerAsync: (actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => void;
    examinationViewerAsync: (accountid: string, idid: string, actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => void;
    setPosNextPrev: (pos: number) => void;
    setLoading: (loading: boolean) => void;
}

export interface Location {
    hash: string;
    pathname: string;
    search: string;
}

export interface OwnProps {
    history: History;
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        initRevisionViewer: (actId: string, revision: string, miekesi: boolean, highlight: string, nodeId: string, mode: 'history' | 'current') => dispatch(
            appActions.initRevisionViewerAsync(actId, revision, miekesi, highlight, nodeId, mode)),
        initEditingViewer: (actId: string, editingId: string, stepId: string, miekesi: boolean) => dispatch(
            appActions.initEditingViewerAsync(actId, editingId, stepId, miekesi)),
        initExaminationViewerAsync: (actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => dispatch(
            appActions.initExaminationViewerAsync(actId, editingId, stepId, examinationtype, miekesi)),
        examinationViewerAsync: (accountid: string, idid: string, actId: string, editingId: string, stepId: string, examinationtype: string, miekesi: boolean) => dispatch(
            appActions.examinationViewerAsync(accountid, idid, actId, editingId, stepId, examinationtype, miekesi)),
        setPosNextPrev: (pos: number) => dispatch(viewerActions.setPosNextPrev(pos)),
        setLoading: (sdMenu: boolean) => dispatch(appActions.setLoading(sdMenu)),
    };
}

const mapStateToProps = (state, history) => {
    return Object.assign({}, state.appState, state.viewerState, history.history);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);